import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import InspectionItem from '../InspectionItem'
import { translation } from '../../../../utils/helpers'

import { QualityCheckIcons } from '../../../../shared/elements/icons'

// Elements
import Grid from '../../../../shared/elements/grid'
import Button from '../../../../shared/elements/button'
import Check from '../../../../shared/elements/check'
import Text from '../../../../shared/elements/text'
import Inline from '../../../../shared/elements/inline'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Icon from '../../../../shared/elements/icon'
import Divider from '../../../../shared/elements/divider'
import RemoveButton from '../../../../shared/elements/removeButton'

class ProcessComments extends Component {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.renderContent = this.renderContent.bind(this)
  }

  componentDidMount () {
  }

  renderContent () {
    // Add comment
    const addComment = () => {
      let obj = {
        OrderId: this.props.order.Id,
        Text: '',
        Step1Start: false,
        Step1End: false,
        Step2Start: false,
        Step2End: false,
        Step3Start: false,
        Step3End: false,
        Step4Start: false,
        Step4End: false,
        Step5Start: false,
        Step5End: false,
        Step6Start: false,
        Step6End: false,
        Step7Start: false,
        Step7End: false,
        Step8: false,
        Step101Start: false,
        Step101End: false,
        Step102Start: false,
        Step102End: false,
        Step103Start: false,
        Step103End: false,
        Step104Start: false,
        Step104End: false,
        Step105Start: false,
        Step105End: false
      }
      let processComment = { ...this.props.processComment }
      let propName = 'ProcessComments'
      // if (this.props.isBodyshop) propName = 'BodyshopProcessComments'
      processComment[propName].push(obj)
      this.props.saveProcessComment(processComment)
    }
    const renderProcessComment = (item, key) => {
      const onBlur = () => {
        this.props.onBlur()
      }
      const onChange = (e) => {
        this.props.onChange(e, key, this.props.isBodyshop)
      }
      const deleteItem = (e) => {
        this.props.deleteItem(e, key, this.props.isBodyshop)
      }
      const renderIcon = (icon, title) => {
        return (
          <div className='hint--top' aria-label={translation(title)} key={title}>
            <Icon icon={icon} title={translation(title)} />
          </div>
        )
      }
      const renderStepCheckbox = (item, name, checked, disabled) => {
        let id = name + item.Id
        if (disabled === undefined) disabled = false
        return (
          <Check labelText={id} id={id} name={id} onChange={onChange} checked={checked} disabled={disabled} simple />
        )
      }
      const renderIcons = () => {
        if (this.props.isBodyshop) {
          return (
            <Grid justify='center' align='center'>
              {renderIcon(QualityCheckIcons.Quality_Check_New, '164')}
              {renderIcon(QualityCheckIcons.Quality_Check_Disassembly, '617')}
              {renderIcon(QualityCheckIcons.Quality_Check_Repair, '618')}
              {this.props.auth.departmentType === 1 && renderIcon(QualityCheckIcons.Quality_Check_Coating, '161')}
              {renderIcon(QualityCheckIcons.Quality_Check_Assembly, '619')}
              {renderIcon(QualityCheckIcons.Quality_Check_Preparing_Body, '162')}
              {renderIcon(QualityCheckIcons.Quality_Check_Handover, '163')}
            </Grid>
          )
        }
        if (this.props.auth.departmentType === 0) {
          return (
            <Grid justify='center' align='center'>
              {renderIcon(QualityCheckIcons.Quality_Check_New, '164')}
              {renderIcon(QualityCheckIcons.Quality_Check_Pretreatment, '96')}
              {renderIcon(QualityCheckIcons.Quality_Check_Filler, '160')}
              {renderIcon(QualityCheckIcons.Quality_Check_Sanding, '158')}
              {renderIcon(QualityCheckIcons.Quality_Check_Coating, '161')}
              {renderIcon(QualityCheckIcons.Quality_Check_Preparing, '162')}
              {renderIcon(QualityCheckIcons.Quality_Check_Handover, '163')}
              {renderIcon(QualityCheckIcons.Quality_Check_Finished, '1231')}
            </Grid>
          )
        }
        return (
          <Grid justify='center' align='center'>
            {renderIcon(QualityCheckIcons.Quality_Check_Pretreatment, '96')}
            {renderIcon(QualityCheckIcons.Quality_Check_Filler, '160')}
            {renderIcon(QualityCheckIcons.Quality_Check_Sanding, '158')}
            {renderIcon(QualityCheckIcons.Quality_Check_Coating, '161')}
            {renderIcon(QualityCheckIcons.Quality_Check_Preparing, '162')}
            {renderIcon(QualityCheckIcons.Quality_Check_Finished, '1231')}
          </Grid>
        )
      }
      const renderSteps = (isStop) => {
        let stepType = 'Start'
        if (isStop) stepType = 'End'
        if (this.props.isBodyshop) {
          return (
            <Grid justify='center' align='center'>
              {renderStepCheckbox(item, 'Step1' + stepType + '_', item['Step1' + stepType])}
              {renderStepCheckbox(item, 'Step101' + stepType + '_', item['Step101' + stepType], this.props.order.OrderDepartment === 0)}
              {renderStepCheckbox(item, 'Step102' + stepType + '_', item['Step102' + stepType], this.props.order.OrderDepartment === 0)}
              {this.props.auth.departmentType === 1 && renderStepCheckbox(item, 'Step105' + stepType + '_', item['Step105' + stepType])}
              {renderStepCheckbox(item, 'Step103' + stepType + '_', item['Step103' + stepType], this.props.order.OrderDepartment === 0)}
              {renderStepCheckbox(item, 'Step104' + stepType + '_', item['Step104' + stepType], this.props.order.OrderDepartment === 0)}
              {renderStepCheckbox(item, 'Step7' + stepType + '_', item['Step7' + stepType])}
            </Grid>
          )
        }
        if (this.props.auth.departmentType === 0) {
          return (
            <Grid justify='center' align='center'>
              {renderStepCheckbox(item, 'Step1' + stepType + '_', item['Step1' + stepType])}
              {renderStepCheckbox(item, 'Step2' + stepType + '_', item['Step2' + stepType])}
              {renderStepCheckbox(item, 'Step3' + stepType + '_', item['Step3' + stepType])}
              {renderStepCheckbox(item, 'Step4' + stepType + '_', item['Step4' + stepType])}
              {renderStepCheckbox(item, 'Step5' + stepType + '_', item['Step5' + stepType])}
              {renderStepCheckbox(item, 'Step6' + stepType + '_', item['Step6' + stepType])}
              {renderStepCheckbox(item, 'Step7' + stepType + '_', item['Step7' + stepType])}
              {!isStop && renderStepCheckbox(item, 'Step8_', item.Step8)}
              {isStop && <div />}
            </Grid>
          )
        }
        return (
          <Grid justify='center' align='center'>
            {renderStepCheckbox(item, 'Step2' + stepType + '_', item['Step2' + stepType])}
            {renderStepCheckbox(item, 'Step3' + stepType + '_', item['Step3' + stepType])}
            {renderStepCheckbox(item, 'Step4' + stepType + '_', item['Step4' + stepType])}
            {renderStepCheckbox(item, 'Step5' + stepType + '_', item['Step5' + stepType])}
            {renderStepCheckbox(item, 'Step6' + stepType + '_', item['Step6' + stepType])}
            {!isStop && renderStepCheckbox(item, 'Step8_', item.Step8)}
          </Grid>
        )
      }
      return (
        <div key={key}>
          <Inline block fillChildNum={[0]}>
            <Text onChange={onChange} onBlur={onBlur} value={item.Text} />
            <RemoveButton onClick={deleteItem} round />
          </Inline>
          {renderIcons()}
          <LabelWrapper labelText={translation('271')}>
            {renderSteps(false)}
          </LabelWrapper>
          <LabelWrapper labelText={translation('2062')}>
            {renderSteps(true)}
          </LabelWrapper>
          <Divider />
        </div>
      )
    }
    return (
      <div>
        {this.props.processComment && this.props.processComment.ProcessComments.map(renderProcessComment)}
        <Button style='secondary' onClick={addComment} labelText={translation('1208')} />
        {/* <img src='/images/svgs/inspection/add-white.svg' /> */}
      </div>
    )
  }
  render () {
    if (!this.props.processComment) return null
    let title = {
      icon: '/images/svgs/inspection/comment.svg',
      text: '15091'
    }
    const headerClick = () => {
      let processComment = 'ProcessComment'
      if (this.props.isBodyshop) processComment = 'BodyshopProcessComment'
      this.props.onHeaderClick(processComment)
    }
    return (
      <InspectionItem title={title} renderContent={this.renderContent} checked={this.props.processComment.Checked} onHeaderClick={headerClick} />
    )
  }
}

ProcessComments.defaultProps = {
  isBodyshop: false
}

ProcessComments.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  saveProcessComment: PropTypes.func.isRequired,
  // processComment: React.PropTypes.object.isRequired,
  onHeaderClick: PropTypes.func.isRequired,
  isBodyshop: PropTypes.bool,
  order: PropTypes.object.isRequired
}

ProcessComments.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(ProcessComments)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/ProcessComments/index.js